import { defineAsyncComponent } from 'vue'
export default {
  "csp-csppublic": defineAsyncComponent(() => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/layouts/csp/csppublic.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/layouts/default.vue").then(m => m.default || m))
}